module.exports = __webpack_public_path__ + "static/media/enter.534792ee.svg";